import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';

export const utagAffirmBanner = (eventType, interaction) => {
  const interactionType = {
    eventType,
    interaction,
  };
  const userInteractionEvent = createUserInteraction(interactionType);
  trackEvent(userInteractionEvent);
};
